module.exports = __webpack_public_path__ + "static/media/logo-iclips.27b9710b.svg";